import HeroBg from "public/zadaraMigration/Network-Services_ migratetozadara.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Run Smarter. Leave EC2 Limits Behind ",
    link: "contact-us",
  },
  desc: "Move your AWS EC2 workloads to Zadara’s flexible edge cloud with OneMind’s migration automation, platform support, and expert-guided execution. ",
  title: "Simplify Your Cloud. Unlock Control. Migrate from EC2 to Zadara. ",
  image: HeroBg,
};
